import { CssType, ThemeType } from 'src/theme/jss-types';
import {
  getSelectStyleForSelectWithInput,
  getTextInputStyleForSelectWithInput,
  refreshButton,
} from 'src/theme/cssSnippets/commonSnippets';
import { MIN_WIDTH, MOBILE_BREAK_POINT } from 'src/globals';

export const AssignedVehicleStyles = (theme: ThemeType): CssType => ({
  mainDiv: {
    display: 'flex',
    flexDirection: 'column',
    '& .ant-checkbox-inner': {
      width: '15px',
      height: '15px',
    },
    '& .anticon-down': {
      fontSize: '12px',
    },
    '& .ant-btn ant-dropdown-trigger': {
      borderColor: theme.primaryColor,
      color: theme.primaryColor,
    },
    minWidth: MIN_WIDTH,
  },
  tabsContainer: {
    flexGrow: 1,
    padding: '10px',
    backgroundColor: '#f9f9f9',
    '& .ant-tabs-bar, .ant-tabs-nav': {
      margin: '0px',
    },
    '& .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab': {
      marginRight: 0,
    },
    '& .ant-tabs-tab': {
      width: '184px',
    },
    '& .ant-tabs-tab-btn': {
      width: '100%',
    },
  },
  tabPane: {
    borderLeft: '1px solid #e8e8e8',
    borderRight: '1px solid #e8e8e8',
    borderBottom: '1px solid #e8e8e8',
  },
  dateFilterSelectStyle: {
    ...getSelectStyleForSelectWithInput(),
  },
  searchStyle: {
    ...getTextInputStyleForSelectWithInput(),
    minWidth: '100px',
    maxWidth: '150px',
    '& .ant-input': {
      borderRadius: '0 4px 4px 0',
    },
  },
  noWidthInput: {
    width: 'auto',
    margin: '0 !important',
    '& .ant-input': {
      width: '0px',
      padding: '0',
      borderRight: 'none',
    },
  },
  noLeftBorder: {
    '& .ant-select-selection': {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
  },
  datePicker: {
    width: 240,
    border: '1px solid #D9D9D9 !important',
    borderRadius: '0 4px 4px 0 !important',
    '& .ant-calendar-picker-input': {
      borderRadius: '0 4px 4px 0',
      padding: 0,
    },
    '& .ant-calendar-range-picker-separator': {
      verticalAlign: 'baseline',
    },
  },
  hubSearch: {
    display: 'flex',
    '& .ant-select-selection': {},
  },
  searchDropdown: {
    padding: '0px 2px',
    background: '#fafafa',
    borderRadius: '4px 0 0 4px',
    width: 100,
  },
  metricValue: {
    color: 'white',
    minWidth: 26,
    height: 18,
    borderRadius: 9,
    padding: '0 5px',
    margin: '0 5px',
  },
  selectStyle: getSelectStyleForSelectWithInput(),
  select: {
    marginRight: 16,
    '& .ant-select-selector': {
      border: '1px solid #D9D9D9 !important',
      borderRadius: '4px 0 0 4px !important',
    },
  },
  table: {
    margin: '16px 0',
    '& .ant-table-pagination.ant-pagination': {
      margin: '-60px 24px 16px',
    },
  },
  selectWithoutBorder: {
    margin: '0 5px',
  },
  refreshButton: {
    ...refreshButton({ color: theme.primaryColor }),
    marginTop: 0,
    marginLeft: 4,
  },
  [`@media (max-width: ${MOBILE_BREAK_POINT}px)`]: {
    tabsContainer: {
      '& .ant-tabs-tab': {
        width: '120px',
      },
      '& .ant-table-wrapper': {
        overflowX: 'scroll',
      },
    },
  },
});
